<template>
  <div class="wrapper">
    <div class="main">
      <div class="section">
        <div class="container">
          <md-card class="bar-breadcrumb">
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item">
                  <router-link to="/">{{ $t("主页") }}</router-link>
                  <span class="breadcrumb-slash">/</span>
                  <router-link to="/products">{{ $t("产品") }}</router-link>
                  <span class="breadcrumb-slash">/</span>
                  <span>{{product.name_cn}}</span>
                </div>
              </div>
            </md-card-content>
          </md-card>

          <div class="md-layout">
            <div class="md-layout-item md-size-30 md-xsmall-size-100">
              <img class="img-raised rounded" :src="product.image_url" />

              <div class="md-layout">
                <div
                  class="md-layout-item md-size-30"
                  v-for="(image_url, image_url_index) in product.image_urls"
                  :key="image_url_index"
                >
                  <img :src="image_url" class />
                </div>
              </div>
            </div>
            <div class="md-layout-item md-xsmall-size-100">
              <div class="md-display-1">{{product.name_cn}}</div>
              <div class="md-headline">${{product.price}}</div>
              <md-divider class="divider-content"></md-divider>
              <div
                class="md-body-1"
              >{{product.description_cn}}</div>
              <md-divider class="divider-content"></md-divider>

              <div class="md-layout">
                <div class="md-layout-item md-size-20 md-small-size-50">
                  <div class="container-flex_center">
                    <md-button class="md-icon-button md-dense md-simple" @click="onClickMinusQty">
                      <md-icon>remove</md-icon>
                    </md-button>

                    <md-field md-inline>
                      <md-input placeholder="1" class="input-qty" v-model="product_quantity"></md-input>
                    </md-field>

                    <md-button class="md-icon-button md-dense md-simple" @click="onClickPlusQty">
                      <md-icon>add</md-icon>
                    </md-button>
                  </div>
                </div>

                <div class="md-layout-item container-add_to_cart">
                  <!-- <router-link :to="{ name: 'cart', params: {}}"> -->
                  <md-button class="md-primary" @click="onClickAddToCart">{{ $t("加到购物车") }}</md-button>
                  <!-- </router-link> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <md-dialog-alert
      :md-active.sync="show_alert"
      :md-content="alert_message"
      md-confirm-text="確定" />

      <md-dialog-confirm
      :md-active.sync="show_confirm"
      md-title="提示"
      md-content="成功加到購物車"
      md-confirm-text="前住購物車"
      md-cancel-text="繼續瀏覽"
      @md-cancel="onCancelConfirm"
      @md-confirm="onConfirmConfirm" />
      
  </div>
</template>

<script>
export default {
  components: {},
  name: "product",
  bodyClass: "product-page",
  props: {},
  data() {
    return {
      product: {},
      product_quantity: 1,
      show_alert : false,
      show_confirm: false,
      alert_message : '',
    };
  },
  methods: {
    onCancelConfirm(){
      this.show_confirm = false;
    },
    onConfirmConfirm(){
      this.$router.push({ name: "cart", params: {} });
    },
    onClickPlusQty() {
      if(!this.$_.isInteger(parseFloat(this.product_quantity))){
        this.product_quantity = 0;  
      }
      this.product_quantity++;
    },

    onClickMinusQty() {
      if(!this.$_.isInteger(parseFloat(this.product_quantity))){
        this.product_quantity = 1;  
      }

      if(this.product_quantity <= 1 ){
        return;
      }
      this.product_quantity--;
    },

    onClickAddToCart() {
      if(!this.$_.isInteger(parseFloat(this.product_quantity))){
        this.alert_message = '請輸入數字';
        this.show_alert = true;
        return;
      }else if (parseInt(this.product_quantity) <= 0){
        this.alert_message = '數量不得少於0';
        this.show_alert = true;
        return;
      }
      this.addToCart();
    },

    async addToCart() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "wx_cart_add.php",
        data: {
          member_id: this.$store.state.member_id,
          product_id: this.$route.params.id,
          quantity: this.product_quantity
        }
      });

      this.show_confirm = true;
      // this.$router.push({ name: "cart", params: {} });
    },

    async getProduct() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "wx_product_get.php",
        data: {
          search_criteria: {
            product_id: this.$route.params.id
          }
        }
      });
      this.product = response.data.products[0];
      this.loader.hide();
    }
  },
  computed: {},
  async created() {
    await this.getProduct();
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  beforeDestroy() {}
};
</script>
<style lang="scss">
.item-no_of_result {
  text-align: right;
}

.title-category {
  padding-top: 10px;
  padding-bottom: 10px;
}

.md-card.card-bar-top {
  margin-top: 30px;
}

.input-qty {
  text-align: center;
  width: 100%;
}

.md-divider.divider-content {
  margin-top: 10px;
  margin-bottom: 10px;
}

.container-add_to_cart {
  display: flex;
  align-items: center;
}

</style>